export default {
  cascade: 'Каскад',
  dz: 'ДЗ',
  pdz: 'ПДЗ',
  pdn: 'ПДН',
  promisedDate: 'Дата обещания',
  promiseCreatedDate: 'Дата создания обещания',
  sumCreditLimit: 'Сумма кредитного лимита',
  weeklyPayments: 'Платежи за 7 дней',
  withAdvancePayment: 'С авансом',
  paymentSchedule: 'График платежей',
  history: 'История',
  pledges: 'Обеспечение',
  noPaymentsByCurrentCustomer: 'По данному клиенту нет платежей',
  noTasksByCurrentCustomer: 'По данному клиенту нет задач',
  noPromisesByCurrentCustomer: 'По данному клиенту нет обещаний',
  noPledgesByCurrentCustomer: 'По данному клиенту нет обеспечений',
  noFilesByCurrentCustomer: 'По данному клиенту нету файлов',
  invoiceBalanceDue: 'Остаток',
  responsibleGroup: 'Ответственная группа',
  promise: 'Обещание',
  newPromise: 'Новое обещание',
  createNewPromise: 'Создать новое обещание',
  enterPromisedAmount: 'Введите сумму обещания',
  contactPerson: 'Контактное лицо',
  contactPhone: 'Телефон контактного лица',
  newPromiseCreated: 'Обещание добавлено',
  actOfRevision: 'Акт сверки',
  createActOfRevision: 'Сформировать акт сверки',
  createClaim: 'Сформировать претензию',
  createPaymentSchedule: 'Сформировать график платежей',
  companyCode: 'Балансовая единица',
  fileUpload: 'Загрузка файлов',
  managerName: 'ФИО руководителя',
  managerPosition: 'Должность',
  claimNumber: 'Номер претензии',
  claimDate: 'Дата претензии',
  newClaim: 'Новая претензия',
  openDebt: 'Сумма просроченного долга по договору',
  fileTypeNotSelected: 'Тип файла не выбран',
};
